var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 171,
    viewBox: "0 0 189 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 87.3075,
    cy: 86.0184,
    r: 6.0184,
    fill: "#2AD062"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.7281,
    cy: 86.4391,
    r: 3.43909,
    fill: "#2AD062"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5879,
    cy: 86.2989,
    r: 4.29886,
    fill: "#2AD062"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.8684,
    cy: 86.5793,
    r: 2.57931,
    fill: "#2AD062"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "lighten"
    }
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.3075,
    cy: 86.0184,
    r: 6.0184,
    fill: "#2AD062"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.1672,
    cy: 86.8782,
    r: 6.87817,
    fill: "#2AD062"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5879,
    cy: 86.2989,
    r: 4.29886,
    fill: "#2AD062"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5879,
    cy: 86.2989,
    r: 4.29886,
    fill: "#2AD062"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2459_77492)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.2891,
    y: 45,
    width: 80,
    height: 80,
    rx: 40,
    fill: "#2AD062",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.2891,
    y: 45,
    width: 80,
    height: 80,
    rx: 40,
    stroke: "#2AD062",
    strokeOpacity: 0.5,
    strokeWidth: 16,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.661 74.6444C109.498 75.5035 109.498 76.8965 108.661 77.7556L91.5186 95.3556C90.6817 96.2148 89.325 96.2148 88.4881 95.3556L79.9167 86.5556C79.0799 85.6965 79.0799 84.3035 79.9167 83.4444C80.7535 82.5852 82.1103 82.5852 82.9471 83.4444L90.0033 90.6887L105.631 74.6444C106.468 73.7852 107.825 73.7852 108.661 74.6444Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2459_77492",
    x: 34.2891,
    y: 29,
    width: 120,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2459_77492"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2459_77492",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDone);
export default __webpack_public_path__ + "static/media/done.731cab47fc86d6261854a3b1ef2e0667.svg";
export { ForwardRef as ReactComponent };